import { render, staticRenderFns } from "./form_detail_subcategories_marketplace_component.vue?vue&type=template&id=f2a8cb30&scoped=true"
import script from "./form_detail_subcategories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./form_detail_subcategories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_subcategories_marketplace_component.vue?vue&type=style&index=0&id=f2a8cb30&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a8cb30",
  null
  
)

export default component.exports